import { useCallback, useEffect, useState } from "react";
import { ticketService } from "../services/ticketService";

export function useTicket(ticketId?: number | null) {
    console.log("useTicket called with ticketId:", ticketId);
    const [ticket, setTicket] = useState<any>(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const fetchTicket = useCallback(async () => {
        if (ticketId == null || Number.isNaN(ticketId)) {
            setTicket(null);
            setError("Identifiant de ticket invalide.");
            setLoading(false);
            return;
        }
        setLoading(true);
        setError(null);
        try {
            const response = await ticketService.getTicketById(ticketId);
            setTicket(response.data ?? response ?? null);
        }
        catch (err: any) {
            setError(err.message ?? "Impossible de charger le ticket.");
        }
        finally {
            setLoading(false);
        }
    }
    , [ticketId]);
    useEffect(() => {
        fetchTicket();
    }, [fetchTicket]);
    return { ticket, loading, error, reload: fetchTicket };
}
